// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"cec727f7","47":"6ba7516d","178":"d091d9e1","179":"2d845506","284":"9b82aa50","404":"5cbfbe79","453":"237d86e6","467":"78736b76","517":"f37027e6","528":"a4104b48","534":"8e6a964a","654":"9e7e6229","767":"d6c55350","820":"be56f4b2","874":"5f0c9f1f","890":"3e4bdd86"}[chunkId] + ".chunk.js";
};